var _polygon, _polygon2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-414"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.94,466.69c13-20.61,28-40.27,47.15-53.31s43.11-18.77,64.21-10.47c15.57,6.13,29.19,19.5,45.63,20.63,13.54.93,26.46-6.8,37-16.54,19.61-18.14,33.15-43.29,51-63.69s43.23-36.57,67.66-29.14c17.26,5.26,30.33,21.19,40.7,37.74,19.84,31.64,33.48,76.38,39.65,114.58Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.8,77.8h79.44s-7-12.79-27.47-10.93c-19.53,1.78-20.52-6.29-30.45-7.28S224.11,66.21,220.8,77.8Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.83,163.72h59.88s-5.3-9.63-20.71-8.23c-14.72,1.34-15.47-4.74-22.95-5.49S398.33,155,395.83,163.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.21,224.71H194.38s-12.13-22.07-47.44-18.86c-33.72,3.07-35.43-10.86-52.58-12.57S62.93,204.71,57.21,224.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.79,
    cy: 105.05,
    r: 21.15,
    transform: "translate(-38.15 122.02) rotate(-46.84)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.56,157.38c-.31,0-.55-7.13-.55-15.92s.24-15.92.55-15.92.55,7.13.55,15.92S121.86,157.38,121.56,157.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.61,103.86c0,.3-7.41.55-16.56.55s-16.57-.25-16.57-.55,7.41-.55,16.57-.55S173.61,103.55,173.61,103.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.79,57.41c.3,0,.55,6.53.55,14.59s-.25,14.58-.55,14.58-.56-6.53-.56-14.58S121.48,57.41,121.79,57.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.13,105.84c0,.31-7.88.55-17.6.55s-17.59-.24-17.59-.55,7.88-.55,17.59-.55S107.13,105.54,107.13,105.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.32,95.08c-.21.22-4.63-3.86-9.87-9.1s-9.32-9.66-9.1-9.88S95,80,100.23,85.2,109.54,94.86,109.32,95.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,76.41c.22.22-2.91,3.75-7,7.88s-7.56,7.32-7.77,7.1,2.91-3.74,7-7.87S150.77,76.2,151,76.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.94,135.3c-.22.21-4.51-3.74-9.6-8.82s-9-9.38-8.81-9.59,4.51,3.73,9.6,8.81S153.15,135.08,152.94,135.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.78,114.85c.22.22-5,5.85-11.77,12.58s-12.33,12-12.55,11.81,5.05-5.85,11.77-12.59S115.57,114.64,115.78,114.85Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-414"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.15,466.49c0,.16-95.65.28-213.61.28s-213.62-.12-213.62-.28,95.62-.27,213.62-.27S470.15,466.34,470.15,466.49Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-414"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149,327h0a9.74,9.74,0,0,0,13.64-4.87l2.16-5.28s7.35,2.61,11.09-4.13,11-22.93,11-22.93h0a26.76,26.76,0,0,0-25.28-9.8l-1.42.23-15.42,34.2A9.75,9.75,0,0,0,149,327Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.45,300.86a1.12,1.12,0,1,1,1.42.68A1.11,1.11,0,0,1,178.45,300.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.48,299.73c-.17.06-.56-.81-1.49-1.32s-1.87-.39-1.91-.56.2-.24.62-.3a2.55,2.55,0,0,1,1.6.3,2.63,2.63,0,0,1,1.11,1.2C181.58,299.44,181.56,299.71,181.48,299.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.34,295.37a1.11,1.11,0,0,1-.4,1.52,1.12,1.12,0,1,1-1.12-1.93A1.1,1.1,0,0,1,170.34,295.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.28,295.11c-.17.06-.56-.81-1.49-1.32s-1.87-.39-1.91-.56.2-.24.61-.3a2.6,2.6,0,0,1,2.72,1.5C171.37,294.82,171.36,295.09,171.28,295.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.48,305a4.94,4.94,0,0,1,1.68.5c.26.1.49.15.57,0a1.55,1.55,0,0,0,.21-.8c.09-.74.18-1.5.28-2.29.44-3.26.93-5.87,1.1-5.85a30.11,30.11,0,0,1-.5,5.93c-.11.79-.22,1.54-.33,2.29a1.76,1.76,0,0,1-.42,1.08.72.72,0,0,1-.63.17,2.13,2.13,0,0,1-.44-.17A5.18,5.18,0,0,1,170.48,305Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.85,316.75a17.89,17.89,0,0,1-7.48-7.28s-.54,6,6.55,9Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.07,287.8c-.11-.12-5.42-3.27-7,2.53-1.37,5,4.3,5.88,4.37,5.72S157.07,287.8,157.07,287.8Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.42,293.11s-.1,0-.27,0a.94.94,0,0,1-.63-.22,2.24,2.24,0,0,1-.27-2.21,2.89,2.89,0,0,1,.68-1.11,1,1,0,0,1,.86-.4.45.45,0,0,1,.41.41c0,.15,0,.24,0,.26s.13-.05.17-.26a.61.61,0,0,0-.08-.37.7.7,0,0,0-.42-.29,1.24,1.24,0,0,0-1.14.42,3,3,0,0,0-.79,1.23,2.32,2.32,0,0,0,.46,2.52,1,1,0,0,0,.81.15C153.37,293.22,153.43,293.12,153.42,293.11Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,293.18c.78,1.15,2.62,1,3.7.13a9.91,9.91,0,0,0,2.23-3.47,21,21,0,0,1,3.2-4.66,3.89,3.89,0,0,1,6.61-.11,9.55,9.55,0,0,0,3.23,2.56c1.73.61,3.69-.07,5.44.45s2.76,1.9,4.05,3a7.53,7.53,0,0,0,4.6,2,4.25,4.25,0,0,0,4.07-2.51,3,3,0,0,0-2.06-4,2.46,2.46,0,0,0,1.91-3.2A3.91,3.91,0,0,0,189.7,281a10.26,10.26,0,0,0-4.23.66,2.87,2.87,0,0,0-1.54-3.24,6,6,0,0,0-3.8-.38c-1.28.22-2.53.61-3.82.71-2.58.2-5.09-.8-7.6-1.42s-5.4-.83-7.47.73c-1.83,1.37-2.16,3.87-3,6s-1.12,2.69-1.94,4.76C156.28,288.79,154.86,291.55,156,293.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.07,308.22c0,.07-.35.06-.81-.16a3.31,3.31,0,0,1-1.83-3.36c.07-.51.24-.79.3-.77a7.85,7.85,0,0,0,.57,2.47C169,307.64,170.13,308.08,170.07,308.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.23,287.46a1,1,0,0,1,0,1.16,1.93,1.93,0,0,1-1.1.88,2.15,2.15,0,0,1-1.81-.35,5.72,5.72,0,0,1-1.56-1.64,9.28,9.28,0,0,0-1.61-2,3.88,3.88,0,0,0-2.61-.73c-1,0-2,.25-3,.38a5,5,0,0,1-3.05-.36,4.84,4.84,0,0,1-1.85-2.18,6.53,6.53,0,0,0-1.44-2.07,3.72,3.72,0,0,0-2-.78,4.16,4.16,0,0,0-3,.93,5.1,5.1,0,0,0-.78.89,2.75,2.75,0,0,1,.72-.95,4.15,4.15,0,0,1,3-1,3.83,3.83,0,0,1,2.12.79,6.43,6.43,0,0,1,1.51,2.11,4.63,4.63,0,0,0,1.78,2.09,4.86,4.86,0,0,0,2.92.33c1-.13,2-.35,3-.38a4.05,4.05,0,0,1,2.75.8,9.35,9.35,0,0,1,1.63,2,5.72,5.72,0,0,0,1.49,1.62,2.08,2.08,0,0,0,1.7.37,1.93,1.93,0,0,0,1.06-.81A1.23,1.23,0,0,0,189.23,287.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.81,282.37a.6.6,0,0,1,.29-.09,1,1,0,0,1,.77.34,1.07,1.07,0,0,1,.12,1.3,1.65,1.65,0,0,1-1.58.76,3.32,3.32,0,0,1-1.93-1,11.86,11.86,0,0,0-1.83-1.6,2.88,2.88,0,0,0-2.54-.15,9.56,9.56,0,0,1-2.85.75,3.74,3.74,0,0,1-2.59-1.36,10.44,10.44,0,0,0-2-1.8,6.34,6.34,0,0,0-4.35-.92,6.5,6.5,0,0,0-2.82,1.18,9.26,9.26,0,0,0-.87.73,4.06,4.06,0,0,1,.82-.8,6.34,6.34,0,0,1,2.84-1.26,6.49,6.49,0,0,1,4.49.89,11.29,11.29,0,0,1,2.05,1.82,3.51,3.51,0,0,0,2.43,1.3,9.6,9.6,0,0,0,2.78-.73,3.13,3.13,0,0,1,2.71.17,12.68,12.68,0,0,1,1.86,1.65,3.23,3.23,0,0,0,1.81,1,1.52,1.52,0,0,0,1.46-.67,1,1,0,0,0-.08-1.18,1,1,0,0,0-.7-.36A1.76,1.76,0,0,0,187.81,282.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.66,278.42c-.16,0-.15-1-.81-2s-1.56-1.38-1.51-1.53.3-.06.7.12a3.17,3.17,0,0,1,1.79,2.71C164.83,278.17,164.73,278.43,164.66,278.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.19,272.87c.13.11-.56,1.07-1,2.43s-.41,2.53-.57,2.54a3.64,3.64,0,0,1,0-2.71A3.72,3.72,0,0,1,166.19,272.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.41,295.7c.06,0,0,.53-.6.93a1.66,1.66,0,0,1-1.27.15,1.57,1.57,0,0,1-1-1.21,1.5,1.5,0,0,1,1.71-1.85c.75.11,1,.6.91.62s-.35-.25-.93-.23a1.32,1.32,0,0,0-.87.33,1.17,1.17,0,0,0-.28,1,1.12,1.12,0,0,0,.66.83,1.32,1.32,0,0,0,.92,0C152.17,296.06,152.33,295.67,152.41,295.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,290.88a2.67,2.67,0,0,1,.61-2.13,5,5,0,0,1,2-1.4,2.67,2.67,0,0,0,1-.87,4,4,0,0,0,.45-1.41,5.71,5.71,0,0,1,1.08-2.79,3.2,3.2,0,0,1,2.07-1.26,2.58,2.58,0,0,1,1.63.26,1.52,1.52,0,0,1,.47.37s-.17-.13-.51-.3a2.63,2.63,0,0,0-1.56-.17,3,3,0,0,0-1.94,1.23,5.64,5.64,0,0,0-1,2.69,4.34,4.34,0,0,1-.49,1.5,2.89,2.89,0,0,1-1.14.93,5,5,0,0,0-1.95,1.32,3.65,3.65,0,0,0-.68,1.44A4,4,0,0,0,156,290.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.47,459.78l11.26.75,1.53-21.08L72.8,438.18l-.18,1.3c-.74,5.8-3.38,29.51-2.49,33.49C71.13,477.4,76.47,459.78,76.47,459.78Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.55,468.37s-2.27,6.15-3.25,5.29.79-24.93,2.5-35.48l.47.07L71,466.31S73.59,467.14,73.55,468.37Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.31,437.92a1.31,1.31,0,0,0-.07.36c0,.31-.09.65-.14,1-.12,1-.27,2.31-.44,3.82-.36,3.22-.79,7.69-1.15,12.63s-.6,9.42-.73,12.67q-.07,2.26-.12,3.84c0,.39,0,.73,0,1a1.53,1.53,0,0,0,0,.37s0-.13,0-.36,0-.66.06-1.05c0-1,.12-2.32.2-3.84.17-3.24.44-7.71.8-12.65s.77-9.4,1.08-12.64c.14-1.5.26-2.78.36-3.82,0-.39.06-.73.09-1S73.31,437.92,73.31,437.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.64,466.28a7.82,7.82,0,0,1,1.78.85,9,9,0,0,1,1.37,1.41,2.84,2.84,0,0,0-1.22-1.62A2.81,2.81,0,0,0,70.64,466.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.26,460.29c-.05.06.29.38.76.72s.87.58.91.52-.3-.38-.76-.72S74.3,460.23,74.26,460.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.28,458.65s.14.39.44.78.59.66.65.62-.14-.39-.44-.78S75.34,458.6,75.28,458.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.35,457.72a2.43,2.43,0,0,0-.22,1.08,2.53,2.53,0,0,0,0,1.12,2.74,2.74,0,0,0,.22-1.09A2.45,2.45,0,0,0,77.35,457.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.78,457.45a3.17,3.17,0,0,0-.37,2.48,8,8,0,0,0,.18-1.24A6.35,6.35,0,0,0,78.78,457.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,461.14a3.81,3.81,0,0,0-.09,1.35,8,8,0,0,0,.21,1.47,4.68,4.68,0,0,0,.28.85.77.77,0,0,0,.4.37.56.56,0,0,0,.56-.17,2.48,2.48,0,0,0-.51-3.12,2.33,2.33,0,0,0-.87-.51c-.22-.07-.36-.08-.36-.06a3.6,3.6,0,0,1,1.11.7,2.45,2.45,0,0,1,.67,1.21,2.16,2.16,0,0,1-.23,1.61c-.18.2-.42.1-.55-.15a4.33,4.33,0,0,1-.27-.79,8.82,8.82,0,0,1-.26-1.42C76.05,461.66,76.08,461.14,76,461.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,461.48a1.28,1.28,0,0,0,.93.23,2.22,2.22,0,0,0,1-.3,1.35,1.35,0,0,0,.78-1.07.55.55,0,0,0-.6-.47,1.46,1.46,0,0,0-.62.19,4,4,0,0,0-.87.58,2.08,2.08,0,0,0-.6.73s.26-.25.72-.59a5,5,0,0,1,.85-.51c.3-.16.83-.25.86.09s-.35.66-.64.85a2.22,2.22,0,0,1-.91.32A4.41,4.41,0,0,1,76,461.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,438.77c-.05,0,0,.61-.17,1.56a6.71,6.71,0,0,1-1.65,3.29,6.78,6.78,0,0,1-3.15,1.91c-.93.25-1.54.24-1.54.29a1.62,1.62,0,0,0,.43,0,5.38,5.38,0,0,0,1.15-.15,6.41,6.41,0,0,0,4.94-5.34,5.62,5.62,0,0,0,.06-1.16A1.1,1.1,0,0,0,79,438.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.65,441.6a37.82,37.82,0,0,0-4.31-.5,37.85,37.85,0,0,0-4.34-.24,38.21,38.21,0,0,0,4.32.5A37.82,37.82,0,0,0,87.65,441.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.27,448.64a12.48,12.48,0,0,0-.53,3.06,12.08,12.08,0,0,0,0,3.1c.08,0,.09-1.39.23-3.08S74.34,448.66,74.27,448.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.58,444.51c0-.05-.3.09-.63.21s-.61.17-.61.25.33.13.7,0S74.63,444.56,74.58,444.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.63,443.1c0-.06-.27.06-.51.26s-.39.41-.35.47.28-.07.52-.27S76.68,443.15,76.63,443.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.68,440.93c-.07,0-.09.29-.22.59s-.32.52-.27.58.35-.1.5-.48S77.75,440.92,77.68,440.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.21,439.38c-.06,0-.18.08-.26.25s-.09.33,0,.36.18-.08.26-.25S78.28,439.41,78.21,439.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.61 438.84 78.41 459.93 80.95 460.08 80.95 438.77 79.61 438.84",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,460.63l-.23-11.28-21.14.31.17,16.5,1.31.07c5.84.24,29.7.8,33.58-.43C207,464.41,189,460.63,189,460.63Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.83,462.79s6.32,1.73,5.55,2.77-24.9,1.39-35.56.6l0-.47,28.15-.15S196.6,462.86,197.83,462.79Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.52,465.68l.36,0,1.05,0,3.84.11c3.25.07,7.73.11,12.69,0s9.43-.22,12.68-.38l3.84-.21,1-.07a1.45,1.45,0,0,0,.36-.05H203l-1.05,0-3.84.13c-3.24.11-7.73.24-12.68.31s-9.43.05-12.68,0l-3.84,0h-1.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,465.87a8.42,8.42,0,0,1,.69-1.84,8,8,0,0,1,1.29-1.49,2.75,2.75,0,0,0-1.51,1.35A2.83,2.83,0,0,0,196,465.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.72,462.79c.06,0,.35-.33.65-.82s.5-.92.44-1-.35.33-.65.82S189.66,462.75,189.72,462.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,461.91s.38-.17.74-.51.61-.64.57-.69-.38.17-.74.5S188,461.86,188,461.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.89,459.93a2.46,2.46,0,0,0,1.1.13,2.64,2.64,0,0,0,1.1-.13c0-.08-.49-.13-1.1-.13A2.43,2.43,0,0,0,186.89,459.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.49,458.53a2.18,2.18,0,0,0,1.24.34,2.07,2.07,0,0,0,1.27-.19,7.66,7.66,0,0,0-1.25-.07A7.75,7.75,0,0,0,186.49,458.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.41,460.94a4,4,0,0,0,1.36,0,8,8,0,0,0,1.44-.34,4,4,0,0,0,.82-.35.7.7,0,0,0,.33-.43.53.53,0,0,0-.21-.54,2.5,2.5,0,0,0-3.07.77,2.44,2.44,0,0,0-.43.92c-.05.23-.05.36,0,.36a3.83,3.83,0,0,1,.6-1.16,2.44,2.44,0,0,1,1.15-.77,2.12,2.12,0,0,1,1.62.08c.22.16.14.42-.1.56a4,4,0,0,1-.76.34,10.23,10.23,0,0,1-1.39.38C190.93,460.89,190.41,460.9,190.41,460.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.76,461a1.31,1.31,0,0,0,.15-.94,2.3,2.3,0,0,0-.39-1,1.36,1.36,0,0,0-1.14-.68.55.55,0,0,0-.41.63,1.53,1.53,0,0,0,.24.61,4.41,4.41,0,0,0,.65.81c.44.41.77.57.79.54s-.28-.24-.66-.66a5.67,5.67,0,0,1-.58-.81c-.19-.29-.32-.8,0-.87s.69.3.9.57a2.22,2.22,0,0,1,.4.88A4.26,4.26,0,0,1,190.76,461Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.87,459.89c0,.05.6-.06,1.56,0a6.85,6.85,0,0,1,3.43,1.35,7,7,0,0,1,2.17,3c.33.9.37,1.51.42,1.51a1.11,1.11,0,0,0,0-.43,5.17,5.17,0,0,0-.24-1.14,6.55,6.55,0,0,0-2.19-3.12,6.47,6.47,0,0,0-3.56-1.33,5.76,5.76,0,0,0-1.17,0A1.82,1.82,0,0,0,167.87,459.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.94,451.07a35.62,35.62,0,0,0-.12,4.34,37,37,0,0,0,.13,4.35,38.48,38.48,0,0,0,.12-4.35A36.75,36.75,0,0,0,169.94,451.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.11,463.79a12,12,0,0,0,3.09.26,11.55,11.55,0,0,0,3.09-.29c0-.07-1.39,0-3.09,0S178.12,463.72,178.11,463.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,463.84c-.05.05.12.29.26.61s.23.59.3.59.11-.34-.06-.7S174,463.79,174,463.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.38,461.92c0,.05.09.27.32.49s.44.35.49.3-.09-.27-.31-.49S172.43,461.87,172.38,461.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.14,461.06c0,.08.3.07.61.17s.53.27.59.22-.13-.34-.51-.46S170.12,461,170.14,461.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.54,460.67c0,.06.1.17.28.24s.34.06.36,0-.1-.17-.27-.23S168.57,460.6,168.54,460.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.89 459.33 189 458.68 188.93 456.14 167.7 457.99 167.89 459.33",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.78,383.26l66.78-.92s22.5,1.93,17.71,19.33c-3.69,13.44-8.17,32.47-15.7,55.78l-26.57.26,11-47.35c-1.59,0-19.87.61-19.87.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.22,401.08a71.37,71.37,0,0,0-6.88,3.92,71,71,0,0,0-6.05,5.11,7.27,7.27,0,0,1,1.44-1.85,27.7,27.7,0,0,1,4.29-3.72,26.68,26.68,0,0,1,5-2.74A7.47,7.47,0,0,1,189.22,401.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.51,408.19a23.8,23.8,0,0,1-4.24,1.38,22.81,22.81,0,0,1-4.33,1.09,15.33,15.33,0,0,1,4.17-1.62A14.75,14.75,0,0,1,184.51,408.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.52,
    y: 446.85,
    width: 30.59,
    height: 11.16,
    transform: "translate(-0.95 0.38) rotate(-0.12)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.52,438.94l0,0s-56.89-31.07-63.34-41.18a21.78,21.78,0,0,1-1.9-20.22L128.14,384l35.65,32.1-1.6,2c7.42,5.88,20.8,18.17,20.8,30.28,0,20.73-26.81,17.34-46.05,17.39-26.31.06-55.82.18-55.82.18L81,437.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,444.85a50.9,50.9,0,0,1-7-2.75,51.55,51.55,0,0,1-6.79-3.26,52.9,52.9,0,0,1,7,2.75A51.78,51.78,0,0,1,159,444.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.56,437.92a22.94,22.94,0,0,1-5,.44,23,23,0,0,1-5-.11,22.08,22.08,0,0,1,5-.44A23.13,23.13,0,0,1,154.56,437.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.95,
    y: 436.55,
    width: 11.16,
    height: 30.59,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.25,318.86c10.34-7.16,21.25-2.29,26.11,9.3,5.23,12.48,13,26.79,15.07,28,4,2.35,51,23.46,51,23.46l-7.17,14.47s-59-20.23-63.13-27.29-27.36-44.17-27.36-44.17Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.29,398.73c0-.64-.28-.16.77-.82,2.13-1.32.68-2.62.68-2.62s-.48-.57-.39-1c.15-.6.75-.29.75-.29,2.12.43,2.67-.62,2.4-1.49s-1.75-1.83-2-2.31.71-.35.71-.35,2.86.37,3.61-.69.39-1.44-.54-2.1c-.52-.36-6.33-2.49-6.33-3.76s2.16-1.51,4-2.47,4.49-3.62,3.33-4.54-2,0-3.71,1.18-7,2.11-7,2.11L216.09,394s7.11,5.07,8.1,5.69C224.19,399.7,227.28,401.47,227.29,398.73Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.05,397.27s-1,5.51,1.65,6.55C275.89,404.29,278.76,401.22,273.05,397.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.21,395.93s2.78,2.65,4.38,1.5C279.3,396.92,278.61,394.12,274.21,395.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.37,400s2.27,6.58,5.79,6.06C285.74,405.78,287,400.7,278.37,400Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.41,408.87c-.11-.09-11.29-8.93-3.93-19.43,6.74-9.6,19.5-3.11,19.63-3.05l-.49.94a22.17,22.17,0,0,0-6.86-2c-5-.56-8.82,1-11.41,4.72a11.22,11.22,0,0,0-.74,12.62,18.81,18.81,0,0,0,4.45,5.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.61 381.47 221.63 420.68 246.08 434.25 260.62 394.51 269.04 394.36 247.61 381.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.08,434.25c-.1.05-.75-1.51-2.3-3.69A23.75,23.75,0,0,0,236,423.7a29.56,29.56,0,0,0-10-3c-2.67-.32-4.34-.23-4.35-.32a4.09,4.09,0,0,1,1.18-.14,23.26,23.26,0,0,1,3.21.08,26.88,26.88,0,0,1,10.19,2.87,22.53,22.53,0,0,1,7.82,7.11,18.81,18.81,0,0,1,1.56,2.82A4.75,4.75,0,0,1,246.08,434.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.29,370.15c0-.69,17.08-14,17.08-14s-10.32-22-14.84-30Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.53,326.16s-13.25-22.23-33.73-3.52c-13.37,12.21-35.18,37.37-43,47.23-1.74,2.21-4.48,5.57-2.56,7.64,5.84,6.32,21.76,20.46,51.23,9.91l30.31-57Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.54 315.58 146.28 309.47 165.36 324.65 161.79 330.38 142.54 315.58",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.88,321.17a4.78,4.78,0,0,1,0,2.13,7.31,7.31,0,0,1-3.23,4.77,6.44,6.44,0,0,1-3.93,1,28.57,28.57,0,0,1-4.54-.88,6.91,6.91,0,0,0-4.78.23,7.43,7.43,0,0,0-3.15,4.06c-.68,1.7-1,3.51-1.67,5.18a8.08,8.08,0,0,1-3.05,4.16,6.9,6.9,0,0,1-4.58.87,8,8,0,0,1-3.75-1.59,11.08,11.08,0,0,1-3.39-4.72,12.66,12.66,0,0,1-.48-1.51,1.85,1.85,0,0,1-.09-.54s.23.72.77,2a11.26,11.26,0,0,0,3.43,4.49,7.68,7.68,0,0,0,3.57,1.44,6.38,6.38,0,0,0,4.25-.84,7.59,7.59,0,0,0,2.81-3.92c.63-1.62,1-3.42,1.66-5.19a8,8,0,0,1,3.42-4.34,7.34,7.34,0,0,1,5.14-.25,27.92,27.92,0,0,0,4.46.92,6.09,6.09,0,0,0,3.69-.9,7.24,7.24,0,0,0,3.23-4.48A11.1,11.1,0,0,0,149.88,321.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.63,390.85a1.5,1.5,0,0,1-.06-.48,3.54,3.54,0,0,1,.25-1.37,6.9,6.9,0,0,1,3.59-3.5c1.93-1,4.54-1.22,7.15-2.1a7.59,7.59,0,0,0,3.53-2.27,8,8,0,0,0,1.6-4.21c.38-3.15,0-6.37,1.16-9.08a11.28,11.28,0,0,1,5-5.51,10.76,10.76,0,0,1,4.87-1.34,7.79,7.79,0,0,1,1.37.09,1.69,1.69,0,0,1,.47.1c0,.07-.66-.06-1.83,0a11.23,11.23,0,0,0-9.43,6.82c-1.07,2.56-.7,5.71-1.09,9a8.38,8.38,0,0,1-1.73,4.48,8,8,0,0,1-3.78,2.41c-2.71.88-5.27,1-7.14,2a7,7,0,0,0-3.57,3.23A5.54,5.54,0,0,0,99.63,390.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.16,352.68a1.6,1.6,0,0,1,.4-.22,6.35,6.35,0,0,1,1.25-.4,8.67,8.67,0,0,1,4.76.3,8.78,8.78,0,0,1,2.9,1.67,8,8,0,0,1,2.19,3.17,8.64,8.64,0,0,1-8.89,11.9,8,8,0,0,1-3.65-1.21,8.82,8.82,0,0,1-2.43-2.3,8.72,8.72,0,0,1-1.64-4.49,5.59,5.59,0,0,1,0-1.3,1.38,1.38,0,0,1,.09-.45c.06,0,0,.63.09,1.73A8.81,8.81,0,0,0,94,365.36a7.93,7.93,0,0,0,5.8,3.23,8.18,8.18,0,0,0,8.38-11.21,7.91,7.91,0,0,0-4.75-4.65,8.86,8.86,0,0,0-4.59-.46C97.75,352.46,97.18,352.73,97.16,352.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "159.49 367.94 159.5 332.46 165 363.56 159.49 367.94"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "131.61 337.39 123.77 373.26 131.61 373.26 131.49 387.42 133.62 383.11 133.21 369.15 128.03 369.15 131.61 337.39"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.36,316.36s15,13,15.24,12.78,6-4.39,6-4.39l-5.29,3Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M142.39,315.51a3.63,3.63,0,0,1,1,.52c.59.37,1.44.92,2.47,1.63,2.06,1.42,4.84,3.47,7.9,5.74,2.08,1.54,4,3,5.72,4.12h-.25c1.78-1,3.27-1.76,4.32-2.3a10,10,0,0,1,1.69-.78,9.1,9.1,0,0,1-1.56,1c-1,.61-2.46,1.46-4.22,2.47l-.12.07-.13-.09c-1.71-1.12-3.7-2.52-5.78-4.06l-7.8-5.87-2.37-1.77A4.92,4.92,0,0,1,142.39,315.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.35,386.93a12.43,12.43,0,0,0-5-1.13,3.12,3.12,0,0,0-1.25.19,1.21,1.21,0,0,0-.78.94,1.25,1.25,0,0,0,.63,1.15,3.69,3.69,0,0,0,1.31.44l4.12.87",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.45,394.81a12.42,12.42,0,0,0-5-1.12,3,3,0,0,0-1.25.18,1.24,1.24,0,0,0-.78.94A1.27,1.27,0,0,0,222,396a3.69,3.69,0,0,0,1.31.44l4.12.86",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.73,390.89a12.57,12.57,0,0,0-5-1.12,3.32,3.32,0,0,0-1.26.18,1.26,1.26,0,0,0-.78.95,1.3,1.3,0,0,0,.63,1.15,3.76,3.76,0,0,0,1.31.44l4.13.86",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.78,389.86a9.64,9.64,0,0,1-2.32-.39l-2.5-.58c-.47-.12-1-.23-1.48-.37a1.59,1.59,0,0,1-1.31-1.28,1.08,1.08,0,0,1,.47-.93,1.86,1.86,0,0,1,.85-.34,9.25,9.25,0,0,1,1.57,0,20.48,20.48,0,0,1,2.56.29,12.39,12.39,0,0,1,2.31.5,8.55,8.55,0,0,1-2.36-.11,25,25,0,0,0-2.53-.17,10.18,10.18,0,0,0-1.46,0c-.45.06-.89.36-.86.71s.45.67.92.79l1.45.39,2.45.7A9.91,9.91,0,0,1,231.78,389.86Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.22,393.55a9.61,9.61,0,0,1-2.33-.39l-2.5-.58c-.47-.12-1-.23-1.47-.37a1.58,1.58,0,0,1-1.32-1.27,1.15,1.15,0,0,1,.47-.94,1.85,1.85,0,0,1,.86-.34,9.13,9.13,0,0,1,1.56,0,20.48,20.48,0,0,1,2.56.29,11.59,11.59,0,0,1,2.31.51,8.85,8.85,0,0,1-2.36-.12c-.72-.07-1.58-.16-2.53-.17a11.65,11.65,0,0,0-1.45,0c-.46.06-.89.36-.87.71s.45.67.92.79l1.45.4,2.46.69A11.15,11.15,0,0,1,229.22,393.55Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.86,397.46a10.06,10.06,0,0,1-2.32-.4l-2.5-.58c-.47-.11-1-.22-1.48-.37a1.59,1.59,0,0,1-1.31-1.27,1.12,1.12,0,0,1,.47-.94,1.85,1.85,0,0,1,.86-.34,10.21,10.21,0,0,1,1.56,0,18.75,18.75,0,0,1,2.56.29,12.13,12.13,0,0,1,2.31.5,8.36,8.36,0,0,1-2.36-.12c-.72-.07-1.58-.15-2.53-.17a11.87,11.87,0,0,0-1.46.05c-.45.06-.89.35-.86.71s.45.66.92.79l1.45.39,2.46.69A9.6,9.6,0,0,1,227.86,397.46Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.91,431.77l3.61,1.51a33.63,33.63,0,0,0,6,2.65,9.57,9.57,0,0,0,3.22.52,14.56,14.56,0,0,0,4-.43c1.18-.43,2.26.8,1.63,1.74s-3.85,2.2-7.87,1.86.55,4.07,2.19,5.7,6.46,6.93,6.35,7.83c-.15,1.32-1.59,1.4-3.19-.27s-6.73-6.34-7.55-5.43,7.63,9.1,7.63,9.1,2.09,1.46,1.17,2.54c-1.65,1.94-10-7.44-10.75-8.36-.54-.63-1.46.32-.85,1s8.61,8,6.95,10c-1.27,1.53-6.93-7.66-9.43-8.26s5,6.53,3.72,7.95c-.47.52-.9.85-4.61-3.87s-12-19.59-12-19.59l9.93-6.13",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.77,336s-3.09,50.39-.62,54.32,32.57,44.89,32.57,44.89L177.4,445s-43.05-45.13-43.46-53.3S132.32,336,132.32,336Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.45,395.54s-.25.06-.69-.05a3.09,3.09,0,0,1-1.58-1,3.16,3.16,0,0,1-.69-2.71,3.24,3.24,0,0,1,2.29-2.54,2.54,2.54,0,0,1,1.86.15,2.27,2.27,0,0,1,1.15,1.33,1.88,1.88,0,0,1-1.34,2.4,1.54,1.54,0,0,1-1.66-.89c-.18-.44-.07-.71,0-.7s0,.26.23.6a1.33,1.33,0,0,0,1.39.61,1.47,1.47,0,0,0,.94-1.86,1.81,1.81,0,0,0-.91-1,2.06,2.06,0,0,0-1.47-.11,2.77,2.77,0,0,0-1.94,2.11,2.84,2.84,0,0,0,.49,2.37A4.18,4.18,0,0,0,138.45,395.54Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.76,334.09,128.86,369l30.67-.91s.74-28.35-.19-37.75Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.53,368.07a2.38,2.38,0,0,1-.63.08l-1.81.11-6.7.31-22.32.82h-.32l0-.32c.07-.58.14-1.2.22-1.83,1.15-9.1,2.19-17.34,3-23.39.4-2.94.73-5.34,1-7.08.12-.79.22-1.42.29-1.92a2.93,2.93,0,0,1,.14-.67,2.93,2.93,0,0,1,0,.68c0,.5-.11,1.14-.18,1.94-.2,1.74-.46,4.15-.79,7.1-.72,6-1.7,14.3-2.79,23.41-.08.62-.15,1.25-.23,1.83l-.28-.31,22.33-.65,6.7-.14h1.82A2.58,2.58,0,0,1,159.53,368.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.53,368.07c-.15,0-.32-8.45-.37-18.87s0-18.88.18-18.88.32,8.45.37,18.88S159.69,368.07,159.53,368.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.49,368.87a5.26,5.26,0,0,1-.5-1.23,15.76,15.76,0,0,1-.66-3.54,16.63,16.63,0,0,1,13.2-17.58,15.52,15.52,0,0,1,3.6-.35,5,5,0,0,1,1.31.14,27,27,0,0,0-4.82.59,16.74,16.74,0,0,0-12.9,17.18A27.63,27.63,0,0,0,141.49,368.87Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-414"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371,257a6.81,6.81,0,0,1-4.82,2.26,12,12,0,0,1-5.32-1.07c-3.25-1.37-6.09-4.27-8.18-7.12,3.3-2.11,7.81-1.5,10.08-1,3.58.72,9.62,4.19,8.24,7",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.5,182.79a5.46,5.46,0,0,1-3.45,2.54,9.58,9.58,0,0,1-4.36,0,17.15,17.15,0,0,1-7.58-4.33c2.27-2.19,5.93-2.42,7.79-2.42,2.94,0,8.25,1.79,7.6,4.21",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.05,258.11a6.84,6.84,0,0,1,4.17,3.32,11.9,11.9,0,0,1,1.4,5.24c.23,3.52-1.12,7.36-2.74,10.49-3.36-2-4.81-6.33-5.42-8.56-.94-3.53-.52-10.49,2.59-10.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.71,222.56a6.8,6.8,0,0,1,4.16,3.31,12,12,0,0,1,1.41,5.24c.22,3.52-1.13,7.36-2.75,10.49-3.36-2-4.81-6.33-5.41-8.56-.95-3.53-.53-10.48,2.59-10.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,205.66a3,3,0,0,1,.68-.06l2,0,3.12,0a9.72,9.72,0,0,1,2,.13,7.64,7.64,0,0,1,5.58,4.47,7.55,7.55,0,0,1,.63,2.82,15.08,15.08,0,0,1-.13,3,7.7,7.7,0,0,1-7.19,6.25c-1.19,0-2.36,0-3.57,0l.2-.08-2.54,2.53-3.22,3.23-.47.47v-6.63c.53.53.14.15.25.27h0c-.28,0-.57,0-.85-.06a7.8,7.8,0,0,1-5.43-3.25,7.53,7.53,0,0,1-1.19-2.75,12.1,12.1,0,0,1-.18-2.78,7.65,7.65,0,0,1,4.82-7.13,7.9,7.9,0,0,1,3-.51l1.9,0a2.89,2.89,0,0,1,.66.06,5,5,0,0,1-.66.05l-1.9,0a7.64,7.64,0,0,0-2.9.58,7.38,7.38,0,0,0-4.5,6.86,11.49,11.49,0,0,0,.2,2.68,7.12,7.12,0,0,0,1.14,2.57,7.32,7.32,0,0,0,5.09,3c.26,0,.53,0,.8,0h0c.12.12-.25-.27.28.26v2.49c0,1.14,0,2.3,0,3.48l-.47-.2,3.22-3.23,2.54-2.53.08-.08H368c1.2,0,2.41,0,3.55,0a7,7,0,0,0,3.16-.89,7.31,7.31,0,0,0,3.57-4.9,14.59,14.59,0,0,0,.14-2.95,7.35,7.35,0,0,0-.56-2.66,7.45,7.45,0,0,0-3.24-3.58,7.69,7.69,0,0,0-2-.73,9.89,9.89,0,0,0-1.91-.17l-3.12,0-2,0A5.09,5.09,0,0,1,365,205.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.9,113.69s-1-6-8.29-5.85-7.6,9.28-6.54,12.63,14.3,18.85,14.3,18.85l12.77-15.38a11.26,11.26,0,0,0,1.33-12.65c-1.09-1.94-2.71-3.45-5.11-3.45C311.23,107.84,309.9,113.69,309.9,113.69Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.33,300.18a4.47,4.47,0,0,0,2.7-4.11,4.2,4.2,0,1,0-8.38-.11,4.48,4.48,0,0,0,2.63,4.2c-6.45.91-6.21,7.92-6.21,7.92l15.23.2S340.71,301.2,334.33,300.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.11,334.93l-7.75,10.62a.34.34,0,0,0,.07.47l3.95,2.88a.35.35,0,0,0,.48-.07L359.73,338l2.86,2.08a.33.33,0,0,0,.46-.05L365.7,337a.34.34,0,0,0-.06-.5l-3.13-2.29,1.68-2.3a1.21,1.21,0,0,1,1.69-.27l2.21,1.61a.35.35,0,0,0,.48-.07l2.37-3.25a.34.34,0,0,0-.08-.48l-3.72-2.72a4.89,4.89,0,0,0-6.84,1.07L358,331l-2-1.44a.35.35,0,0,0-.48.08l-2.37,3.25a.35.35,0,0,0,.07.48l2,1.44Z",
    style: {
      fill: "#263238",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.56,147.17l-.08-.44a1.15,1.15,0,0,1,.58-.57,7.68,7.68,0,0,0,4.36-4.81c.7-1.82.47-2.16-1.47-2.48l-.33-.05a4.11,4.11,0,0,1-1.22-.42c-.94-.56-.64-1.67.28-2.07.67-.3,1.36,0,2.06,0,.47,0,.62-.21.48-.68a23.08,23.08,0,0,1-.76-3.75,6.46,6.46,0,0,1,2.31-6,8.42,8.42,0,0,1,8.88-1.63,6.43,6.43,0,0,1,4.15,4.29,22.78,22.78,0,0,1,.76,4.26c.06.62.2.72.79.46s1.29-.82,2.14-.61a1.22,1.22,0,0,1,1,.9,1.17,1.17,0,0,1-.28.89,4.63,4.63,0,0,1-1.16.9c-.32.2-.65.37-1,.59a1,1,0,0,0-.3,1.53,8,8,0,0,0,6.25,3.79,1.31,1.31,0,0,1,.87.33c0,.15.05.29.08.44a2.09,2.09,0,0,1-1,1.21,5.63,5.63,0,0,1-1.52.74,1.24,1.24,0,0,0-1.07,1.42c0,.78-.19.93-1,1a5.33,5.33,0,0,1-.56,0,5,5,0,0,0-4,1.65,8.75,8.75,0,0,1-.69.67,5.89,5.89,0,0,1-6.48,1.42c-.67-.24-1.31-.55-2-.83a3.91,3.91,0,0,0-1.7-.29,10.22,10.22,0,0,0-2.67.65c-.45.13-.92.08-1-.39-.27-1.14-1-1.29-2-1.22a5.14,5.14,0,0,1-1.39-.17A1.93,1.93,0,0,1,333.56,147.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.28,317.07a2.76,2.76,0,0,0,1.67-2.55,2.61,2.61,0,1,0-5.2-.06,2.77,2.77,0,0,0,1.64,2.6c-4,.57-3.87,4.92-3.87,4.92l9.47.12S270.24,317.71,266.28,317.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.74,214.39a2.22,2.22,0,1,1-2.22-2.22A2.22,2.22,0,0,1,293.74,214.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,209.94a2.23,2.23,0,1,1-2.23-2.22A2.22,2.22,0,0,1,300,209.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,219.36a2.23,2.23,0,1,1-2.23-2.41A2.32,2.32,0,0,1,300,219.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.1,219.08a12,12,0,0,1-3.3-1.88c-1.73-1.17-3.06-2.24-3-2.38a12,12,0,0,1,3.3,1.88C295.87,217.87,297.2,218.94,297.1,219.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.28,209.78a10,10,0,0,1-2.55,2.37A10.08,10.08,0,0,1,291.8,214c-.1-.14,1-1.19,2.55-2.37A10.37,10.37,0,0,1,297.28,209.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.27,158.91l1.55.23,4.06-4,.45-3s2.41.21,1.55,4-.41,2.89-.41,2.89,5.09.79,5.45,1.27-.33,5.21-.67,7.84a2.88,2.88,0,0,1-2.53,2.55,2.61,2.61,0,0,1-.56,0c-1.27-.19-7.61-2.15-7.61-2.15l-2.67-.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.95 157.43 274.39 167.72 277.04 168.12 278.53 158.18 274.95 157.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.59,200.6a6.37,6.37,0,0,0-7.61-1.71c-4.59,1.89-3.73,7.15-3.73,7.15s-9.32-.16-12.43-6.06c0,0-2.48,4.81,1.4,8.08l-2.18-.62s-.92,5.28,4.05,6.21h-2.33s.93,4.82,5.12,4.51c0,0-.46,2.79-8.08,2.64,0,0,11.5,7.77,21.13-1.09,7.77-7.15,6.37-14.76,6.37-14.76l3-3.26-2.8.77,1.71-3.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.75,348a7.6,7.6,0,0,1,5.77-1.51,13.47,13.47,0,0,1,5.63,2.26c3.31,2.17,5.84,6,7.56,9.51-4.07,1.65-8.91.06-11.31-.9-3.8-1.52-9.74-6.57-7.65-9.36",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.23,357.77a6.51,6.51,0,0,1-4.57-4.66,8.66,8.66,0,0,1,1.1-6.57,3.64,3.64,0,0,1,2.37-1.93,2.81,2.81,0,0,1,2.54,1.23,5.71,5.71,0,0,1,.89,2.79c.31,3.37,0,6.68-2.33,9.14",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.06,367.17s0,.15-.4-.17-1-.79-1.77-1.4a28.39,28.39,0,0,1-5.16-5.39,14.08,14.08,0,0,1-2.57-7,9,9,0,0,1,.14-2.27,2.46,2.46,0,0,1,.23-.8,18.68,18.68,0,0,0,0,3A14.67,14.67,0,0,0,303.1,360a31.78,31.78,0,0,0,5,5.4A19.48,19.48,0,0,1,310.06,367.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.85,367.33c-.84-.45-2.23-1.24-3.57-1.95-2.78-1.47-6.62-3.5-10.9-5.68s-8.17-4.11-11-5.5L281,352.55a6.87,6.87,0,0,1-1.2-.65,7.86,7.86,0,0,1,1.27.5c.81.34,2,.86,3.41,1.52,2.86,1.32,6.78,3.2,11.06,5.38s8.11,4.26,10.85,5.81c1.37.77,2.75,1.62,3.51,2.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.37,365a15.21,15.21,0,0,0-13.48,3.31c-.92.81-1.8,2-1.39,3.16s1.84,1.54,3.07,1.58a13,13,0,0,0,12.07-7.85",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.05,368.57s.19-.21.59-.53a7.33,7.33,0,0,1,.76-.54,12.17,12.17,0,0,1,1.07-.63,16.51,16.51,0,0,1,3-1.22,18.88,18.88,0,0,1,3.89-.67,18.57,18.57,0,0,1,3.95.24,15.82,15.82,0,0,1,3.1.89,11.15,11.15,0,0,1,1.12.5,6.33,6.33,0,0,1,.82.46,2.82,2.82,0,0,1,.65.45c0,.08-1-.52-2.7-1.12a17.86,17.86,0,0,0-3.06-.78,20.81,20.81,0,0,0-3.86-.2,19.57,19.57,0,0,0-3.8.63,17.46,17.46,0,0,0-3,1.1C292,367.94,291.1,368.64,291.05,368.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.94,429.61c-.16,0-.28-65-.28-145.14s.12-145.15.28-145.15.27,65,.27,145.15S310.09,429.61,309.94,429.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.15,307.41a2.56,2.56,0,0,1-.5.31l-1.49.76-5.51,2.71c-4.65,2.28-11.09,5.4-18,9.18A159.68,159.68,0,0,0,316.42,331c-1.06.74-2,1.46-2.78,2.1s-1.51,1.17-2.06,1.65-.93.79-1.28,1.07a2.29,2.29,0,0,1-.47.35,2.57,2.57,0,0,1,.4-.43l1.21-1.15c.52-.51,1.2-1.09,2-1.73s1.7-1.41,2.75-2.18a141,141,0,0,1,17.17-10.78c6.95-3.78,13.43-6.85,18.13-9l5.58-2.55,1.53-.68A3.57,3.57,0,0,1,359.15,307.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.49,231.15c.09.12-10.73,8.37-24.17,18.41s-24.41,18.1-24.5,18,10.73-8.37,24.17-18.42S358.39,231,358.49,231.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.09,252.74a14.77,14.77,0,0,1-1.71-.81c-1.09-.55-2.65-1.37-4.56-2.42-3.83-2.09-9.05-5.1-14.68-8.64s-10.6-7-14.14-9.5c-1.77-1.27-3.18-2.32-4.15-3.07a14.2,14.2,0,0,1-1.47-1.19,10.41,10.41,0,0,1,1.6,1l4.25,2.92c3.59,2.46,8.59,5.81,14.21,9.35s10.8,6.6,14.57,8.77l4.47,2.57A10.76,10.76,0,0,1,310.09,252.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.21,312.9a4.46,4.46,0,0,1-.65-.37l-1.8-1.14-6.6-4.26c-5.58-3.58-13.32-8.48-22-13.7s-16.61-9.78-22.39-13L250,276.55l-1.86-1.06a3.9,3.9,0,0,1-.63-.4,3.47,3.47,0,0,1,.68.3l1.91,1c1.65.85,4,2.11,6.93,3.69,5.83,3.17,13.81,7.68,22.48,12.91s16.39,10.17,21.91,13.84c2.77,1.84,5,3.34,6.51,4.41l1.75,1.23A3.77,3.77,0,0,1,310.21,312.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.13,379.9c.06.14-1,.48-11.77,4.86s-19.47,7.81-19.53,7.67,8.59-3.81,19.32-8.18S341.07,379.76,341.13,379.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.14,297.27a7,7,0,0,1-.83-1.11c-.51-.73-1.21-1.81-2-3.18a65.69,65.69,0,0,1-5.37-11.23A57.86,57.86,0,0,1,275,269.64c-.19-1.58-.3-2.87-.33-3.76a6.26,6.26,0,0,1,0-1.39,6.72,6.72,0,0,1,.21,1.37c.1.88.27,2.16.51,3.72a66.78,66.78,0,0,0,3.05,12,78.28,78.28,0,0,0,5.18,11.23c.78,1.38,1.42,2.5,1.88,3.26A5.83,5.83,0,0,1,286.14,297.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.69,279.76a32.8,32.8,0,0,0-1.88,5.91c-.6,3.39,0,6.18-.18,6.21a14,14,0,0,1,2.06-12.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,313.21a5,5,0,0,1,.67-1,10.89,10.89,0,0,1,.88-1,17.12,17.12,0,0,1,1.28-1.28,24.73,24.73,0,0,1,3.74-2.88,26.32,26.32,0,0,1,10.84-3.84,24.87,24.87,0,0,1,4.72-.13c.67,0,1.27.13,1.8.19a12.09,12.09,0,0,1,1.34.25,5.88,5.88,0,0,1,1.12.32c0,.11-1.64-.28-4.28-.37a27.76,27.76,0,0,0-4.64.24,30.41,30.41,0,0,0-5.51,1.35,30,30,0,0,0-5.12,2.43,27.3,27.3,0,0,0-3.75,2.73C271.08,312,270.07,313.28,270,313.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.58,254.64c-.05.09-1.82-.81-4.83-1.85a47.07,47.07,0,0,0-5.4-1.46,49.77,49.77,0,0,0-6.78-.85,48.78,48.78,0,0,0-6.84.21,43.48,43.48,0,0,0-5.51.94c-3.1.74-4.94,1.48-5,1.38a6.24,6.24,0,0,1,1.27-.58,16.26,16.26,0,0,1,1.54-.55c.61-.2,1.29-.44,2.08-.63a40.16,40.16,0,0,1,5.54-1.07,44.21,44.21,0,0,1,6.92-.25,46.32,46.32,0,0,1,6.87.9,39.75,39.75,0,0,1,5.42,1.6c.76.25,1.42.57,2,.81a16.19,16.19,0,0,1,1.48.71A6.28,6.28,0,0,1,363.58,254.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.45,302.84a2.73,2.73,0,0,1,.06.91,23.23,23.23,0,0,1-.12,2.5,37.52,37.52,0,0,1-1.66,8.08,38.25,38.25,0,0,1-3.35,7.54c-.54.91-1,1.63-1.36,2.11a3.14,3.14,0,0,1-.58.71c-.08-.05.62-1.15,1.6-3a45.82,45.82,0,0,0,5-15.47C332.29,304.13,332.36,302.83,332.45,302.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.77,167.56c.09.12-8.07,7-18.24,15.3s-18.5,15-18.59,14.87,8.07-7,18.24-15.3S346.67,167.44,346.77,167.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.76,182.91c0,.1-1.36-.46-3.59-1a27.92,27.92,0,0,0-4-.63,32.08,32.08,0,0,0-4.9,0,31.38,31.38,0,0,0-4.82.88,27.61,27.61,0,0,0-3.78,1.34c-2.09.92-3.29,1.7-3.35,1.62s.27-.25.8-.62a20.3,20.3,0,0,1,2.39-1.36,25,25,0,0,1,3.8-1.47,25.66,25.66,0,0,1,9.91-.91,24.74,24.74,0,0,1,4,.76,18.07,18.07,0,0,1,2.59.9A4.45,4.45,0,0,1,349.76,182.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.35,370.79a7,7,0,0,0-7.09-6.93l-18.17.2a7,7,0,0,0-6.93,7.09l.09,8.52a7,7,0,0,0,7.09,6.93l18.18-.2a7,7,0,0,0,6.93-7.09Zm-11.42,4.82-7.2,4.05c-.31.18-.6-.05-.59.85l-.09-8.16c0-1.62.27-1.85.59-1.67l7.34,4.1A.47.47,0,0,1,351.93,375.61Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.84,259.91a1.53,1.53,0,1,0,1.54,1.53A1.53,1.53,0,0,0,242.84,259.91Zm-6.8,2a6.43,6.43,0,1,0,6.43,6.43A6.44,6.44,0,0,0,236,261.87Zm0,10.55a4.12,4.12,0,1,1,4.12-4.12A4.13,4.13,0,0,1,236,272.42ZM249,263a7.84,7.84,0,0,0-7.84-7.85H230.82A7.84,7.84,0,0,0,223,263v10.35a7.85,7.85,0,0,0,7.85,7.85h10.35a7.85,7.85,0,0,0,7.84-7.85Zm-2.45,10.35a5.39,5.39,0,0,1-5.39,5.39H230.82a5.39,5.39,0,0,1-5.39-5.39V263a5.39,5.39,0,0,1,5.39-5.39h10.35a5.39,5.39,0,0,1,5.39,5.39Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.58 423.76 296.76 466.47 324.32 466.47 331.12 423.76 311.5 423.76 289.58 423.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.58,
    y: 423.76,
    width: 41.53,
    height: 7.83,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.9 431.59 329.87 431.59 329.2 435.78 290.9 431.59",
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.6a0349db1cec6505a8e80af853c5d050.svg";
export { ForwardRef as ReactComponent };